import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material'
import React, { useContext, useRef, useState } from 'react'
import { UserContext } from '../../../../App'
import {
  DatePicker,
  TimePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
import AnDateField from '../../../../components/DateTime/DateField'
import AnTimeField from '../../../../components/DateTime/TimeField'
import { IncidentContext } from './ReportIncident'
import { INCIDENT_LOCATIONS, INCIDENT_TYPES } from '../incidentConstants'

const Step1 = () => {
  const user = useContext(UserContext).user
  const { formValues, setFormValues, setTab } = useContext(IncidentContext)

  const [incidentType, setIncidentType] = useState(
    formValues?.incidentType ?? '',
  )
  const [incidentDate, setIncidentDate] = useState(
    formValues?.incidentDate ?? moment(),
  )
  const [incidentLocation, setIncidentLocation] = useState(
    formValues?.incidentLocation ?? '',
  )

  const handleNext = (e) => {
    e.preventDefault()
    setFormValues((prev) => ({
      ...prev,
      incidentType,
      incidentDate,
      incidentLocation,
    }))
    setTab((prev) => prev + 1)
    window.scrollTo(0, 0)
  }
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={1}
      component="form"
      onSubmit={handleNext}
    >
      <Typography variant="title2" fontSize="1rem">
        About the Incident
      </Typography>
      <Typography variant="title3" fontSize="1rem">
        Person Filling out this form
      </Typography>
      <TextField
        disabled
        value={user.firstName + ' ' + user.lastName}
        label="Name"
      />
      <TextField disabled value={user.email} label="Email" />
      <FormControl fullWidth required>
        <InputLabel id="incident-type-label">Incident Type</InputLabel>
        <Select
          labelId="incident-type-label"
          id="incident-type"
          label="Incident Type"
          value={incidentType}
          onChange={(e) => setIncidentType(e.target.value)}
          defaultValue=""
        >
          {INCIDENT_TYPES.map((type) => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en-GB">
        <Box display="flex" gap={1}>
          <AnDateField
            date={incidentDate}
            onChange={(newDate) => setIncidentDate(newDate)}
            label="Incident Date"
            fullWidth
          />
          <AnTimeField
            time={incidentDate}
            onChange={(newTime) => setIncidentDate(newTime)}
            label="Incident Time"
            fullWidth
          />
        </Box>
      </LocalizationProvider>
      <FormControl fullWidth required>
        <InputLabel id="incident-location-label">Incident Location</InputLabel>
        <Select
          labelId="incident-location-label"
          id="incident-location"
          label="Incident Location"
          value={incidentLocation}
          onChange={(e) => setIncidentLocation(e.target.value)}
          defaultValue=""
        >
          {INCIDENT_LOCATIONS.map((location) => (
            <MenuItem key={location} value={location}>
              {location}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Box display="flex" gap={1} justifyContent="flex-end">
        <Button
          variant="outlined"
          color="primary"
          onClick={() => setTab((prev) => prev - 1)}
        >
          Previous
        </Button>
        <Button variant="contained" color="primary" type="submit">
          Next
        </Button>
      </Box>
    </Box>
  )
}

export default Step1
